
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Spinner } from '@travelata-libs/ui-kit';

@Component({
    components: {
        Spinner,
    },
})
export default class CheckBoxInputCommon extends Vue {
    @Prop({ default: false }) readonly isChecked!: boolean;
    @Prop({ default: false }) readonly disabled!: boolean;
    @Prop({ default: false }) readonly isDisabledIcon!: boolean;
    @Prop({ default: '' }) readonly label!: string;
    @Prop({ required: true }) readonly value!: string | boolean | number;
    @Prop({ default: true }) readonly hideOverflowText!: boolean;
    @Prop({ default: false }) readonly isHover!: boolean;
    @Prop({ default: true }) readonly isWhiteSpace!: boolean;
    @Prop({ default: 'small' }) readonly checkBoxSize!: string;
    @Prop({ default: false }) readonly loading!: boolean;
    @Prop({ default: false }) readonly isAuthOrRegistration!: boolean;
    @Prop({ default: '' }) readonly checkboxKey!: string;
    @Prop({ default: false }) readonly iconLocked!: boolean;
    @Prop({ default: '' }) readonly domId!: string;

    updateInput(event: Event) {
        if (this.iconLocked) return;
        const checked = (event.target as HTMLInputElement).checked;
        this.$emit('selected', { checked });
    }
}
